import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DspxLogoutComponent } from 'dspx-core';
import { FormResponseComponent } from './components/form-response/form-response.component';
import { LandingComponent } from "./components/landing/landing.component";
import { ROUTE_CONSTANTS } from './constants/route.constants';
import { ComponentDeactivationService } from './services/component-deactivation.service';
import { SuccessfulSubmissionComponent } from './components/successful-submission/successful-submission.component';

const routes: Routes = [
  //{
  //  path: '',
  //  redirectTo: ROUTE_CONSTANTS.maintenanceRequest.prefix,
  //  pathMatch: 'full'
  //  // component: MaintenanceApplicationComponent,
  //},
  {
    path: ROUTE_CONSTANTS.home,
    component: LandingComponent
  },
  {
    path: ROUTE_CONSTANTS.formSubmitted,
    component: SuccessfulSubmissionComponent
  },
  {
    path: ROUTE_CONSTANTS.logout,
    component: DspxLogoutComponent
  },
  // Form Response
  {
    path: ROUTE_CONSTANTS.formResponse.new,
    component: FormResponseComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  {
    path: ROUTE_CONSTANTS.formResponse.edit,
    component: FormResponseComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  //{
  //  path: '',
  //  children: [
  //    {
  //      path: ROUTE_CONSTANTS.maintenanceRequest.prefix,
  //      component: LandingComponent,
  //    }
  //  ]
  //}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
